import { render, staticRenderFns } from "./rich-text-editor.vue?vue&type=template&id=71d196f2&scoped=true"
import script from "./rich-text-editor.ts?vue&type=script&lang=ts&external"
export * from "./rich-text-editor.ts?vue&type=script&lang=ts&external"
import style0 from "./rich-text-editor.less?vue&type=style&index=0&id=71d196f2&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d196f2",
  null
  
)

export default component.exports